import { useEffect, useState } from 'react';
import { BoundingBox } from '../components/Documentation/ImageCard';
import { EdgeSizeChipData } from '../components/Prediction/types';

export function useEdgeSizeBoundingBoxes(edgeEstimationData: EdgeSizeChipData[] | undefined) {
  const [selectedAttribute, setSelectedAttribute] = useState<string | null>();
  const [edgeSizesBoundingBoxes, setEdgeSizeBoundingBoxes] = useState<BoundingBox[]>([]);

  const handleAttributeSelect = (attributeId: string) => {
    setSelectedAttribute(selectedAttribute === attributeId ? null : attributeId);
  };

  useEffect(() => {
    if (!edgeEstimationData || edgeEstimationData.length === 0) return;

    const edgeData = edgeEstimationData[0];
    if (selectedAttribute === 'edge-estimation') {
      setEdgeSizeBoundingBoxes(edgeData.boundingBoxes);
    } else if (selectedAttribute === undefined && edgeData.status === 'CRITICAL') {
      setSelectedAttribute('edge-estimation');
    } else {
      setEdgeSizeBoundingBoxes([]);
    }
  }, [selectedAttribute, edgeEstimationData]);

  return {
    selectedAttribute,
    edgeSizesBoundingBoxes,
    handleAttributeSelect,
  };
}
